export default ({ request }) => ({
    orderBudgetListApi(data = {}) {
      return request({
        url: '/financial/reportBudget/list',
        method: 'post',
        data
      })
    },
    orderBudgetSaveApi(data = {}) {
      return request({
        url: '/financial/reportBudget/save',
        method: 'post',
        data
      })
    },
    orderBudgetDetailApi(data = {}) {
      return request({
        url: '/financial/reportBudget/detail',
        method: 'post',
        data
      })
    },
    orderBudgetDelApi(data = {}) {
      return request({
        url: '/financial/reportBudget/del',
        method: 'post',
        data
      })
    },
    orderBudgetAuditApi(data = {}) {
      return request({
        url: '/financial/reportBudget/audit',
        method: 'post',
        data
      })
    },
    orderBudgetCustomerSaveApi(data = {}) {
      return request({
        url: '/financial/report/budget/customer/save',
        method: 'post',
        data
      })
    },
    orderBudgetCustomerQuarterDelApi(data = {}) {
      return request({
        url: '/financial/report/budget/customer/quarter/del',
        method: 'post',
        data
      })
    },
    orderBudgetCustomerDetailApi(data = {}) {
      return request({
        url: '/financial/report/budget/customer/detail',
        method: 'post',
        data
      })
    },
  })
  